module Dashboard {
    export class ExampleWidgetConfig implements IWidgetConfig {
        public id: string;
        public enabledByDefault: boolean;
        public displayName: string;
        public directiveName: string;
        public gridItemConfig: IGridItemConfig;
        public color: string;
        public environments: string[];

        constructor(id: string) {
            this.id = id;
            this.enabledByDefault = false;
            this.displayName = "Example widget";
            this.directiveName = "frends-example-widget";
            this.gridItemConfig = { col: 0, row: 0, sizeX: 3, sizeY: 2 };
            this.color = "blue";
            this.environments = [];
        }
    }
}